<template>
	 <v-content>
    <the-header menuTitle="Campaign Report"/>
    <v-container class="page-wrapper" style="min-height: 700px;">
    <div class="text-xs-center" v-if="dialog">
         <v-dialog 
            v-model="dialog"
            hide-overlay
            persistent
            width="300"
          >
               <v-card
                  color="primary"
                  dark
                >
                  <v-card-text>
                    Please stand by
                    <v-progress-linear
                      indeterminate
                      color="white"
                      class="mb-0"
                    ></v-progress-linear>
                  </v-card-text>
              </v-card>      
          </v-dialog>
      </div>
      <div v-else>
         <ReportCam></ReportCam> 
      </div> 
    </v-container>
   <!--   <the-footer style="margin-bottom:-44px" /> -->

  </v-content>
</template>

<script>
 // 
  import TheHeader from "@/components/TheHeader";
  import TheFooter from "@/components/TheFooter";
  import ReportCam from '@/components/ReportCam';

  export default {

    components: {
      TheHeader,
      TheFooter,
      ReportCam,
    
    },
    data () {
      return {
        dialog: false
      }
    },
   mounted(){
    //  console.log(this.$store.state.isLoading);
      this.dialog = this.$store.state.isLoading
     // console.log(this.dialog)
    },
    watch: {
      dialog (val) {
        if (!val) return

        setTimeout(() => (this.dialog = false), 3000)
      }
    }
   
  }
</script>